export default defineNuxtPlugin((nuxtApp) => {
  const i18n = nuxtApp.$i18n as any;

  // Get saved locale from cookie
  const savedLocale = useCookie('i18n_locale');

  // Set locale from cookie on app load
  if (savedLocale.value && (savedLocale.value === 'en-US' || savedLocale.value === 'es-ES')) {
    i18n.locale.value = savedLocale.value;
  }

  // Watch for locale changes and save to cookie
  watch(() => i18n.locale.value, (newLocale) => {
    savedLocale.value = newLocale;
  });
});
